export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '0df876ef-e980-4932-b268-3823057a4f4f';
export const MODAL_CLOSE_SEC = 2.5;
